import type { SVGProps } from 'react';

export function IconYoutube(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M33.3477 10.5156C33.9922 13.0352 33.9922 18.25 33.9922 18.25C33.9922 18.25 33.9922 23.5234 33.3477 26.043C32.9961 27.3906 31.8828 28.4453 30.5352 28.8555C28.0156 29.5 17.9961 29.5 17.9961 29.5C17.9961 29.5 7.97656 29.5 5.51562 28.8555C4.10938 28.4453 3.05469 27.3906 2.64453 26.043C2 23.5234 2 18.25 2 18.25C2 18.25 2 13.0352 2.64453 10.5156C3.05469 9.10938 4.10938 8.05469 5.51562 7.70312C7.97656 7 17.9961 7 17.9961 7C17.9961 7 28.0156 7 30.4766 7.70312C31.8828 8.05469 32.9961 9.10938 33.3477 10.5156ZM14.7148 23.0547L23.0938 18.25L14.7148 13.5039V23.0547Z"
                fill="currentColor"
            />
        </svg>
    );
}
